
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "MetricInput": [
      "MetricInputProficiencyRangeEnd",
      "MetricInputProficiencyRangeStart"
    ],
    "QuestionTypeAttributes": [
      "QuestionTypeAttributesFillInTheBlank",
      "QuestionTypeAttributesFreeEntry",
      "QuestionTypeAttributesFreeResponse",
      "QuestionTypeAttributesGraphContains",
      "QuestionTypeAttributesItemBank",
      "QuestionTypeAttributesMultipleChoice",
      "QuestionTypeAttributesOrdering",
      "QuestionTypeAttributesPassageCorrection",
      "QuestionTypeAttributesSnippetSelection",
      "QuestionTypeAttributesTextHighlight",
      "QuestionTypeAttributesTwoWay"
    ],
    "Rubric": [
      "ContainsRubric",
      "CriteriaRubric",
      "EditableRegionsRubric",
      "ExactRubric",
      "GraphContainsRubric",
      "MarkAsCorrectRubric",
      "MathContainsRubric",
      "MostEqualRubric"
    ],
    "SupplementContent": [
      "AudioSupplementContent",
      "FreeFormSupplementContent",
      "ImageSupplementContent",
      "PassageSupplementContent",
      "SortableTableSupplementContent"
    ]
  }
};
      export default result;
    